import { render, staticRenderFns } from "./ServiceOrdersClosedByDay.vue?vue&type=template&id=d0bc6736"
import script from "./ServiceOrdersClosedByDay.vue?vue&type=script&lang=js"
export * from "./ServiceOrdersClosedByDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports